import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type {
  exportTableColumnValidation,
  tableColumnValidation,
  TableSettingColumn,
} from 'types/tableSettingsTypes';

interface AdminAffiliateAnalyticsState {
  excludedFilter: string[];
  filterData: Record<string, any>;
  reloadTableData: boolean;
  tableColumnValidation: tableColumnValidation;
  defaultColumnList: TableSettingColumn[];
  tableColumnList: TableSettingColumn[];
  exportTableColumnValidation: exportTableColumnValidation;
  exportTableColumnList: TableSettingColumn[];
  analyticsFilterData: Record<string, any>;
}

const defaultColumnList: TableSettingColumn[] = [
  // {
  //   name: 'no',
  //   label_key: 'no',
  //   allow_list: true,
  //   allow_filter: false,
  //   show_list_checkbox: true,
  //   show_filter_checkbox: false,
  //   order: 1,
  // },
  {
    name: 'referral_code',
    label_key: 'referral_code',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 2,
  },
  {
    name: 'referred_accounts',
    label_key: 'referred_accounts',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 3,
  },
  {
    name: 'referred_by',
    label_key: 'referred_by',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 4,
  },
  {
    name: 'total_order_amount',
    label_key: 'total_amount_owed',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 5,
  },
  {
    name: 'total_referral_revenue',
    label_key: 'referral_revenue',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 5,
  },
];

const exportColumnList = defaultColumnList.map((list) => ({
  ...list,
  allow_list: true,
  show_list_checkbox: true,
}));

const initialState: AdminAffiliateAnalyticsState = {
  excludedFilter: ['search'],
  filterData: {},
  analyticsFilterData: {},
  reloadTableData: false,
  tableColumnValidation: {
    minListColumn: 2,
    maxListColumn: 8,
    minFilterColumn: 0,
    maxFilterColumn: 8,
  },
  defaultColumnList: defaultColumnList,
  tableColumnList: JSON.parse(JSON.stringify(defaultColumnList)),
  exportTableColumnValidation: {
    minListColumn: 2,
  },
  exportTableColumnList: exportColumnList,
};

const adminAffiliateAnalyticsSlice = createSlice({
  name: 'adminAffiliateAnalytics',
  initialState,
  reducers: {
    setFilterData(state, action: PayloadAction<Record<string, any>>) {
      state.filterData = action.payload;
    },
    setAnalyticsFilterData(state, action: PayloadAction<Record<string, any>>) {
      state.analyticsFilterData = action.payload;
    },
    removeFilterKey(state, action: PayloadAction<string>) {
      delete state.filterData[action.payload];
    },
    resetFilterData(state) {
      state.filterData = {};
    },
    removeAnalyticsFilterData(state, action: PayloadAction<string>) {
      delete state.analyticsFilterData[action.payload];
    },
    resetAnalyticsFilterData(state) {
      state.analyticsFilterData = {};
    },
    setReloadTableData(state, action: PayloadAction<boolean>) {
      state.reloadTableData = action.payload;
    },
    setAffiliateAnalyticsTableColumnList(state, action: PayloadAction<TableSettingColumn[]>) {
      state.tableColumnList = action.payload;
    },
  },
});

export const {
  setFilterData,
  removeFilterKey,
  resetFilterData,
  setAnalyticsFilterData,
  removeAnalyticsFilterData,
  resetAnalyticsFilterData,
  setReloadTableData,
  setAffiliateAnalyticsTableColumnList,
} = adminAffiliateAnalyticsSlice.actions;

export default adminAffiliateAnalyticsSlice.reducer;
